









































































import {
  computed,
  defineComponent,
  onUnmounted,
  PropType,
  ref,
  watch,
} from '@nuxtjs/composition-api'
import { SelectOption } from '@/contracts/FormInput'
import InputError from '@/components/Inputs/new-design/InputError.vue'
import Multiselect from '@/components/Inputs/vue-multiselect/VueMultiselect.vue'

export default defineComponent({
  name: 'InputSelect',
  components: {
    InputError,
    Multiselect,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Object as PropType<SelectOption | string | null>,
      default: () => null,
    },
    noResultText: {
      type: String,
      default: 'Ничего не найдено',
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Boolean],
      default: false,
    },
    selectOptions: {
      type: Array as PropType<SelectOption[]>,
      default: () => [],
    },
    returnOptionValue: {
      type: Boolean,
      default: false,
    },
    validateSelect: {
      type: Function as PropType<
        (option: SelectOption, value: string | SelectOption | null) => boolean
      >,
      default: (option: SelectOption, value: SelectOption | string | null) => {
        if (!value) return false
        if (typeof value === 'string') return (option && option.value) === value
        return (option && option.value) === value.value
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dropdownMaxHeight: {
      type: Number,
      default: 300,
    },
    internalSearch: {
      type: Boolean,
      default: true,
    },
    testId: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const isFocused = ref(false)

    const getValue = computed(() => {
      return props.selectOptions.find((item) =>
        props.validateSelect(item, props.value)
      )
    })

    watch(isFocused, () => {
      if (isFocused) emit('focused')
    })

    const onSelectChange = (option: SelectOption): void => {
      emit('input-change', props.returnOptionValue ? option.value : option)
    }

    const onSearchChange = (search: string): void => {
      emit('search', search)
      if (search === '' && props.value) emit('input-change', null)
    }

    const onClose = () => {
      isFocused.value = false
      emit('blur')
    }

    const onOpen = () => {
      isFocused.value = true
      emit('focus')
    }

    onUnmounted(() => {
      emit('unmounted')
    })

    return {
      isFocused,
      getValue,
      onSearchChange,
      onSelectChange,
      onClose,
      onOpen,
    }
  },
})
